import React, { useContext, useEffect, useMemo, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { createAppError } from 'utils/helpers';
import { AppContext, IAppContext } from 'appState/appContext';
import {
	VideoCategoriesContext,
	IFilterValues,
	IVideoCategoriesContext,
} from '../../../videoCategoriesState/videoCategoriesContext';

const WithURLFilters: React.FC = ({ children }) => {
	const { addAppError } = useContext<IAppContext>(AppContext);
	const { setFiltersFromQueryString, searchString, sortBy, countOfItems, currentPage } =
		useContext<IVideoCategoriesContext>(VideoCategoriesContext);
	const history = useHistory();
	const isMounted = useRef<boolean>(false);

	const queryParams = useMemo(() => history.location.search, [history.location.search]);

	const queryKeyValueSeparator = '=';
	const queryParamsSeparator = '&';

	const filterValues: { [key: string]: IFilterValues[keyof IFilterValues] } = useMemo(() => {
		return {
			searchString,
			sortBy,
			countOfItems,
			currentPage,
		};
	}, [searchString, sortBy, countOfItems, currentPage]);

	const getQueryStringFromState = () => {
		let resultedString = '?';

		for (const filter in filterValues) {
			const currentValue = `${filter}${queryKeyValueSeparator}${filterValues[filter]}${queryParamsSeparator}`;
			if (filterValues[filter]) {
				resultedString += currentValue;
			}
		}

		return resultedString.slice(0, resultedString.length - 1); // remove queryParamsSeparator at the end
	};

	const getStateFromQueryString = () => {
		const filters: IFilterValues = {
			searchString: '',
			sortBy: '',
			countOfItems: '12',
			currentPage: 1,
		};

		const parseQueryStringToObject = () => {
			const properties = queryParams.slice(1).split(queryParamsSeparator);
			properties.forEach((el) => {
				const currentProperty = el.split(queryKeyValueSeparator);
				const propertyKey = currentProperty[0] as keyof IFilterValues;
				const propertyValue =
					typeof currentProperty[1] === 'string'
						? decodeURIComponent(currentProperty[1])
						: currentProperty[1];

				switch (propertyKey) {
					case 'currentPage':
						return (filters[propertyKey] = Number(propertyValue));
					default:
						// @ts-ignore
						return (filters[propertyKey] = propertyValue);
				}
			});
		};
		try {
			parseQueryStringToObject();
		} catch (err) {
			const error = err as Error;
			const appError = createAppError(error);
			addAppError(appError);
		}

		return filters;
	};

	// Set query string from state
	useEffect(() => {
		if (isMounted.current) {
			const queryStringFromState = getQueryStringFromState();
			history.push({
				search: queryStringFromState,
			});
		}
		isMounted.current = true;
	}, [filterValues, isMounted.current]);

	// Set state from query string
	useEffect(() => {
		if (queryParams) {
			const stateFromQueryString = getStateFromQueryString();
			setFiltersFromQueryString(stateFromQueryString);
		}
		isMounted.current = true;
	}, [queryParams]);

	return <>{children}</>;
};

export default WithURLFilters;
